import React from 'react';
import * as S from './Header.styled';
import { LeftArrow, RightArrow } from 'assets/icons';
import { IconButton } from 'components';

const Header = ({ date, decreaseMonth, increaseMonth, minDate }) => {
  const selectedDate = date && new Date(date);
  const isPrevMonthDisabled = selectedDate && selectedDate <= minDate;
  return (
    <S.Container>
      <S.MonthName>
        {date.toLocaleString('default', { month: 'long', year: 'numeric' })}
      </S.MonthName>
      <S.BtnWrap>
        <IconButton.NormalSize
          disabled={isPrevMonthDisabled}
          btnSize='36px'
          iconSize='32px'
          id='left_arrow'
          type={IconButton.btnTypes.tertiary}
          onClick={decreaseMonth}
          icon={LeftArrow}
        />
        <IconButton.NormalSize
          btnSize='36px'
          iconSize='32px'
          id='right_arrow'
          type={IconButton.btnTypes.tertiary}
          onClick={increaseMonth}
          icon={RightArrow}
        />
      </S.BtnWrap>
    </S.Container>
  );
};

export default Header;
